module.exports = __webpack_public_path__ + "static/media/29.c1607184.png";